// eslint-disable react-hooks/exhaustive-deps
import React from 'react';
import { Checkbox, Typography } from '@scale/scaleui';
import { useCreateWebinarSession } from '../hooks/useCreateWebinarSessionStore';

interface ICommunicationsProps {}

export const Communications: React.FC<ICommunicationsProps> = () => {
  const {
    sendInvitationEmails,
    setSendInvitationEmails,
    send30MinuteReminderEmails,
    setSend30MinuteReminderEmails,
  } = useCreateWebinarSession();
  return (
    <>
      <div className="flex gap-1 items-center">
        <Typography.Subtitle3 className="text-neutral-600">
          Automated Communications
        </Typography.Subtitle3>
      </div>
      <div className="flex flex-col gap-y-1 gap-x-4 ml-4">
        <Checkbox
          label="Send invitation emails"
          checked={sendInvitationEmails}
          onChange={e => setSendInvitationEmails(e.target.checked)}
        />
        <Checkbox
          label="Send reminder emails for RSVPs (30 min before session start)"
          checked={send30MinuteReminderEmails}
          onChange={e => setSend30MinuteReminderEmails(e.target.checked)}
        />
      </div>
    </>
  );
};
